/**
 * TaglineManager Module
 * Handles random tagline generation and management
 */

export class TaglineManager {
    taglines: string[];
    currentTagline: string;
    private originalText: string;

    constructor() {
        this.taglines = [
            "Faster than your coffee cools. So easy, your cat could do it!",
            "Faster than a squirrel forgets where it buried a nut. No design skills? No problem.",
            "Faster than your coffee gets cold. Honestly, it's kind of unfair to Canva.",
            "Faster than your Zoom call crashes. Your Roomba might start an art career.",
            "Faster than an AI writes a haiku. You might quit your day job. Don't, but you might.",
            "Faster than your browser loads incognito mode. You'll wonder why you ever Googled 'free design tool'.",
            "Faster than your cat decides to sit on your keyboard. No tutorials, no tears, no regrets.",
            "Faster than a toddler finds the only permanent marker. Honestly, it's embarrassing how easy it is.",
            "Faster than your Wi-Fi reconnects after a storm. You'll feel like a designer. Without the student debt.",
            "Faster than a Gen Z switches TikTok trends. Even your dad's flip phone could handle this.",
            "Faster than a Boomer can forward a chain email. Honestly, they might think it's witchcraft.",
            "Faster than Gen Z cancels a celebrity. Even your reusable water bottle would be impressed.",
            "Faster than a Boomer finishes ranting on Facebook. It's simpler than setting a VCR clock.",
            "Faster than a Gen X'er rolls their eyes at the group chat. It's less effort than finding your Walkman."
        ];
        
        this.currentTagline = "";
        this.originalText = "";
        this.setRandomTagline();
    }

    /**
     * Generate and set a random tagline
     */
    setRandomTagline(): void {
        const randomIndex = Math.floor(Math.random() * this.taglines.length);
        this.currentTagline = this.taglines[randomIndex];
        this.updatePageTagline();
    }

    /**
     * Update the tagline in the document (appends to existing text)
     */
    updatePageTagline(): void {
        const taglineElement = document.querySelector('.description-text');
        if (!taglineElement) return;

        // Check if we already added a tagline (prevent duplicates)
        const existingTagline = taglineElement.querySelector('.tagline-text');
        if (existingTagline) {
            // Just update the existing tagline
            existingTagline.textContent = this.currentTagline;
            return;
        }

        // First time: capture original text and append tagline
        this.originalText = taglineElement.textContent || '';
        taglineElement.innerHTML = `${this.originalText}<br><br><span class="tagline-text" style="color: var(--gray-500);">${this.currentTagline}</span>`;
    }

    /**
     * Set a specific tagline by index
     * @param index - Tagline index (0-13)
     */
    setSpecificTagline(index: number): void {
        if (index < 0 || index >= this.taglines.length) {
            return;
        }
        
        this.currentTagline = this.taglines[index];
        this.updatePageTagline();
    }

    /**
     * Get the current tagline
     * @returns Current tagline
     */
    getCurrentTagline(): string {
        return this.currentTagline;
    }
}
